export default __webpack_public_path__ + "static/media/ico_arrowdown.334be45a.svg";